export default __webpack_public_path__ + "static/landscape-night-a0eadf24ec198045319611aa2970a4a6.jpg";